export const S3_BUCKET = "deliceo-formace-app-v2-upload";
export const REGION = "eu-west-3";
export const ACCESS_KEY = "AKIA3AYWASJ2D3RSZ25X";
export const SECRET_ACCESS_KEY = "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";
